Questa prova contiene _6 problemi_ da risolvere in _50 minuti_, ed è divisa in due parti:
- quattro problemi di **pensiero logico-algoritmico**, e
- due problemi di interpretazione di **procedimenti procedurali** come programmi a blocchi.

In entrambe le parti i problemi sono ordinati per difficoltà crescente.
**Attento che la difficoltà è soggettiva!** Se stai passando tanto tempo cercando di risolvere un problema, prova a passare ad altri problemi e altre categorie!

## Punteggio

Ogni problema comprende _due domande_, valutate separatamente.
La prima domanda è **sempre più semplice**, e può aiutare a rispondere alla seconda domanda.
Le domande sono tutte a **scelta multipla** con 5 opzioni, di cui **solo una** è corretta. Il punteggio che puoi ottenere è:

- 5 punti per una risposta _corretta_;
- 1 punto per una risposta _non data_;
- 0 punti per una risposta _sbagliata_.
